import { Injectable } from '@angular/core';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { Subject } from 'rxjs';

(pdfMake as any).vfs = (pdfFonts as any).vfs;

type CellOptions = {
  align?: 'left' | 'right' | 'center';
  bold?: boolean;
  color?: string;
  fill?: string;
  margin?: number[];
  fs?: number;
  cs?: number;
  rs?: number;
};

type TableLayout = {
  hLineWidth?: (i: number, node?: any) => number;
  vLineWidth?: (i: number, node?: any) => number;
  hLineColor?: (i: number, node?: any) => string;
  vLineColor?: (i: number, node?: any) => string;
  paddingLeft?: (i: number, node?: any) => number;
  paddingRight?: (i: number, node?: any) => number;
  paddingTop?: (i: number, node?: any) => number;
  paddingBottom?: (i: number, node?: any) => number;
};

export type MeterMode = 'both' | 'grid' | 'dg';

@Injectable({
  providedIn: 'root'
})
export class PdfmakeReportService {
private readonly pdfPreviewSubject = new Subject<{ url: string; name: string }>();
pdfPreview$ = this.pdfPreviewSubject.asObservable();
  constructor() { }
content:any
  MakePDF(List: any, mode: any = 'both') {
    console.log(List);
    
    const gv = (d: any, k: any) => (d[k] !== undefined && d[k] !== null) ? String(d[k]) : '';

    function buildPage(d: any, pageNum: any, total: any) {
      const { BRAND_COLOR, BORDER_COLOR, HEADER_FILL, TOTAL_FILL, TEXT_COLOR } = getColors(d);
      const tariff = d.tarrif_card || [];

      const showGrid = mode === 'both' || mode === 'grid';
      const showDG   = mode === 'both' || mode === 'dg';

      const c = (text: any, opts: CellOptions = {}) => ({
        text: text ?? '',
        fontSize: opts.fs ?? 8,
        bold: opts.bold !== false,
        alignment: opts.align ?? 'left',
        color: opts.color ?? TEXT_COLOR,
        ...(opts.cs ? { colSpan: opts.cs } : {}),
        ...(opts.rs ? { rowSpan: opts.rs } : {}),
        ...(opts.margin ? { margin: opts.margin } : {}),
        ...(opts.fill ? { fillColor: opts.fill } : {}),
      });

      const cL   = (t: any, o: CellOptions = {}) => c(t, { align: 'left',   ...o });
      const cR   = (t: any, o: CellOptions = {}) => c(t, { align: 'right',  ...o });
      const cC   = (t: any, o: CellOptions = {}) => c(t, { align: 'center', ...o });
      const cLbl = (t: any) => cL(t, { bold: false, color: '#555555' });

      const ZL_STD: TableLayout = {
        hLineWidth: () => 1, vLineWidth: () => 1,
        hLineColor: () => BORDER_COLOR, vLineColor: () => BORDER_COLOR,
        paddingLeft: () => 4, paddingRight: () => 4,
        paddingTop: () => 2, paddingBottom: () => 1
      };
      const ZL_PARENT: TableLayout = {
        hLineWidth: () => 1, vLineWidth: () => 1,
        hLineColor: () => BORDER_COLOR, vLineColor: () => BORDER_COLOR,
        paddingLeft: () => 0, paddingRight: () => 0,
        paddingTop: () => 0, paddingBottom: () => 0
      };
      const ZL_INNER: TableLayout = {
        hLineWidth: (i) => (i === 0 ? 0 : 1),
        vLineWidth: (i, node) => (i === 0 || i === node.table.widths.length ? 0 : 1),
        hLineColor: () => BORDER_COLOR, vLineColor: () => BORDER_COLOR,
        paddingLeft: () => 4, paddingRight: () => 4,
        paddingTop: () => 2, paddingBottom: () => 1
      };
      const ZL_INNER_LAST: TableLayout = {
        hLineWidth: (i, node) => (i === 0 ? 0 : 1),
        vLineWidth: (i, node) =>
          (i === 0 || i === node.table.widths.length) ? 0 : 1,
        hLineColor: () => BORDER_COLOR,
        vLineColor: () => BORDER_COLOR,
        paddingLeft: () => 4,
        paddingRight: () => 4,
        paddingTop: () => 2,
        paddingBottom: () => 1
      };
      const cTh  = (t: any, o: CellOptions = {}) => cC(t, { color: BRAND_COLOR, fill: HEADER_FILL, bold: true, ...o });
      const cThL = (t: any, o: CellOptions = {}) => cL(t, { color: BRAND_COLOR, fill: HEADER_FILL, bold: true, ...o });
      const cTot = (t: any, o: CellOptions = {}) => cR(t, { bold: true, fill: TOTAL_FILL, ...o });
      const T    = (widths: any, body: any, layout = ZL_STD, m = [0, 0, 0, 0]) =>
        ({ table: { widths, body }, layout, margin: m });

      const out: any[] = [];

      // ── Tariff table body ────────────────────────────────────────────
      let tariffTableBody: any[];
      if (tariff.length) {
        const rows = tariff.map((t: any) => ([cLbl(t.heading), cR(t.content)]));
        tariffTableBody = [
          [cTh('Tariff Card', { cs: 2, fs: 10, margin: [0, 1, 0, 1] }), {}],
          ...rows
        ];
      } else {
        tariffTableBody = [
          [cTh('Tariff Card', { cs: 2, fs: 10, margin: [0, 1, 0, 1] }), {}],
          [cC('', { margin: [0, 35, 0, 35], fill: '#FAFAFA', cs: 2 }), {}]
        ];
      }

      // ── HEADER ───────────────────────────────────────────────────────
const logoContent = getLogoContent(d, BRAND_COLOR, 'center');
const hasLogo = d.logoValue && logoContent.text !== '';

if (hasLogo) {
  out.push({
    columns: [
      { width: '*', text: '' },
      {
        width: 'auto',
        text: gv(d, 'statementTitle').toUpperCase(),
        fontSize: 13, bold: true, color: BRAND_COLOR, letterSpacing: 1,
        margin: [0, 5, 0, 0]
      },
      { width: '*', text: '' },
      {
        width: 80,
        stack: [logoContent],
        alignment: 'right'
      }
    ],
    margin: [0, 0, 0, 6],
  });
} else {
  out.push({
    text: gv(d, 'statementTitle').toUpperCase(),
    fontSize: 13, bold: true, color: BRAND_COLOR,
    letterSpacing: 1, alignment: 'center',
    margin: [0, 5, 0, 6],
  });
}
      out.push({
        columns: [
          { text: [{ text: 'Reading Unit: ', color: '#555' }, { text: 'KWH', bold: true, color: BRAND_COLOR }], fontSize: 8 },
          { text: [{ text: 'Currency: ', color: '#555' }, { text: 'INR (₹)', bold: true, color: BRAND_COLOR }], fontSize: 8, alignment: 'center' },
          { text: `Page ${pageNum} of ${total}`, fontSize: 8, alignment: 'right', color: '#555' },
        ], margin: [0, 0, 0, 4]
      });

      out.push(T(['25%', '25%', '25%', '25%'], [
        [cTh('Site Name'), cTh('GST No.'), cTh('Company Name'), cTh('PAN No.')],
        [cC(gv(d, 'siteName'), { color: BRAND_COLOR }), cC(gv(d, 'gstNo')), cC('Radius', { color: BRAND_COLOR }), cC(gv(d, 'panNo'))],
      ], ZL_STD, [0, 0, 0, 4]));

      // ── SECTION 2 LEFT ───────────────────────────────────────────────

      // Consumer info rows — conditionally show Grid Load / DG Load
      const consumerInfoRows: any[] = [
        [cLbl('Flat/Shop No.'),   cL(gv(d, 'flat'))],
        [cLbl('Consumer Name'),   cL(gv(d, 'consumerName'))],
        [cLbl('Address'),         cL(gv(d, 'address'), { fs: 7, bold: true })],
        [cLbl('Flat Type'),       cL(gv(d, 'flatType'))],
        [cLbl('Area Sq. Ft.'),    cL(gv(d, 'areaSqFt'))],
        ...(showGrid ? [[cLbl('Grid Load'), cL(gv(d, 'gridLoad'))]] : []),
        ...(showDG   ? [[cLbl('DG Load'),   cL(gv(d, 'dgLoad'))]]   : []),
      ];

      // Opening/Closing/Consumed rows — conditionally show Grid / DG rows
      const unitRows: any[] = [
        [cTh('Type'), cTh('Opening\nUnit'), cTh('Closing\nUnit'), cTh('Consumed\nUnit'), cTh('Charges')],
        ...(showGrid ? [[cC('Grid'), cR(gv(d, 'gridOpen')), cR(gv(d, 'gridClose')), cR(gv(d, 'gridConsumed')), cR(gv(d, 'gridUnitChg'))]] : []),
        ...(showDG   ? [[cC('DG'),   cR(gv(d, 'dgOpen')),   cR(gv(d, 'dgClose')),   cR(gv(d, 'dgConsumed')),   cR(gv(d, 'dgUnitChg'))]]   : []),
      ];

      // Breakup rows — conditionally show Grid / DG rows
      const breakupRows: any[] = [
        [cTh('Type', { fs: 7 }), cTh('Consumed', { fs: 7 }), cTh('MMC', { fs: 7 }), cTh('TAX', { fs: 7 }), cTh('Payable', { fs: 7 }), cTh('Chg TAX*', { fs: 7 })],
        ...(showGrid ? [[cC('Grid'), cR(gv(d, 'gridPayConsumed')), cR(gv(d, 'gridPayMMC')), cR(gv(d, 'gridPayTax')), cR(gv(d, 'gridPayTotal')), cR('0.00')]] : []),
        ...(showDG   ? [[cC('DG'),   cR(gv(d, 'dgPayConsumed')),   cR(gv(d, 'dgPayMMC')),   cR(gv(d, 'dgPayTax')),   cR(gv(d, 'dgPayTotal')),   cR('0.00')]]   : []),
        [cL('Total Payable in Electricity', { cs: 4, bold: true, fill: TOTAL_FILL }), {}, {}, {}, cTot(gv(d, 'totalPayable')), cTot('')],
      ];

      const Sec2_Left = [
        T(['33.95%', '*'],      consumerInfoRows, ZL_INNER),
        T(['auto', '24%', '*', '*', '*'], unitRows, ZL_INNER),
        T(['100%'], [[cTh('Breakup Of Electricity Charges', { fs: 9, margin: [0, 1, 0, 1] })]], ZL_INNER),
        T(['16%', '18%', '16%', '16%', '20%', '*'], breakupRows, ZL_INNER_LAST),
      ];

      // ── SECTION 2 RIGHT ──────────────────────────────────────────────

      // Charges Applied — conditionally show Grid/DG specific charges
      const chargesRows: any[] = [
        ...(showGrid ? [
          [cLbl('MMC Grid'),    cR(gv(d, 'mmcGrid'))],
        ] : []),
        ...(showDG ? [
          [cLbl('MMC DG'),     cR(gv(d, 'mmcDG'))],
        ] : []),
        ...(showGrid ? [
          [cLbl('Fixed Grid*'), cR(gv(d, 'fixedGrid'))],
        ] : []),
        ...(showDG ? [
          [cLbl('Fixed DG'),   cR(gv(d, 'fixedDG'))],
        ] : []),
        [cLbl('CAM'),           cR(gv(d, 'cam'))],
        [cLbl('CS'),            cR(gv(d, 'cs'))],
        [cLbl('Other'),         cR(gv(d, 'other'))],
        ...(showDG ? [
          [cLbl('MMC DG GST'),   cR(gv(d, 'mmcDgGst'))],
          [cLbl('Fixed DG GST'), cR(gv(d, 'fixedDgGst'))],
        ] : []),
        [cLbl('CAM GST'),       cR(gv(d, 'camGst'))],
        [cLbl('CS GST'),        cR(gv(d, 'csGst'))],
        [cLbl('Other GST Charges'), cR(gv(d, 'otherGstChg'))],
      ];

      // Tax footnote row — conditionally show Grid Tax / DG Tax cells
      const taxFootnoteRow: any[] = [];
      if (mode === 'both') {
        taxFootnoteRow.push(
          { text: [{ text: '*Grid Tax in %\n', fontSize: 7, bold: true, color: BRAND_COLOR }, { text: gv(d, 'gridTax1'), fontSize: 7, color: '#555' }], fillColor: '#FAFAFA' },
          { text: [{ text: '*Dg Tax in\n',     fontSize: 7, bold: true, color: BRAND_COLOR }, { text: gv(d, 'dgTax1'),   fontSize: 7, color: '#555' }], fillColor: '#FAFAFA' }
        );
      } else if (mode === 'grid') {
        taxFootnoteRow.push(
          { text: [{ text: '*Grid Tax in %\n', fontSize: 7, bold: true, color: BRAND_COLOR }, { text: gv(d, 'gridTax1'), fontSize: 7, color: '#555' }], fillColor: '#FAFAFA', colSpan: 2 },
          {}
        );
      } else {
        taxFootnoteRow.push(
          { text: [{ text: '*Dg Tax in\n', fontSize: 7, bold: true, color: BRAND_COLOR }, { text: gv(d, 'dgTax1'), fontSize: 7, color: '#555' }], fillColor: '#FAFAFA', colSpan: 2 },
          {}
        );
      }

      // const Sec2_Right = [
      //   T(['50%', '50%'], [
      //     [cLbl('Billing Month'), cR(gv(d, 'billingMonth'))],
      //     [cLbl('Meter Sr. No.'), cR(gv(d, 'meterNo'))],
      //   ], ZL_INNER),
      //   T(['100%'], [[cTh('Charges Applied', { fs: 9, margin: [0, 1, 0, 1] })]], ZL_INNER),
      //   T(['50%', '50%'], chargesRows, ZL_INNER),
      //   T(['50%', '50%'], [taxFootnoteRow], ZL_INNER_LAST),
      // ];
      const Sec2_Right = [
        T(['50%', '50%'], [
          [cLbl('Billing Month'), cR(gv(d, 'billingMonth'))],
          [cLbl('Meter Sr. No.'), cR(gv(d, 'meterNo'))],
        ], ZL_INNER),

        // Tariff Card moved here
        T(['50%', '50%'], tariffTableBody, ZL_INNER_LAST),
      ];

      out.push({
        table: { widths: ['50%', '50%'], body: [[{ stack: Sec2_Left }, { stack: Sec2_Right }]] },
        layout: ZL_PARENT, margin: [0, 0, 0, 4]
      });

      // ── SECTION 3 LEFT ───────────────────────────────────────────────
      const Sec3_LeftRows: any[] = [
        [cLbl('Common Area Maintenance'),         cR(gv(d, 'commonAreaMaint'))],
        [cLbl('Common Area Maintenance GST'),     cR(gv(d, 'commonAreaMaintGst'))],
        [cLbl('Common Service'),                  cR(gv(d, 'commonService'))],
        [cLbl('Common Service(CS) GST'),          cR(gv(d, 'commonServiceGst'))],
        ...(showGrid ? [[cLbl('Fixed Grid*'),     cR(gv(d, 'fixedGridStar'))]] : []),
        ...(showDG   ? [
          [cLbl('Fixed DG'),                      cR(gv(d, 'fixedDGVal'))],
          [cLbl('Fixed GST DG'),                  cR(gv(d, 'fixedGstDG'))],
        ] : []),
        [cLbl('Other Charges'),                   cR(gv(d, 'otherChargesVal'))],
        [cLbl('Other GST Charges'),               cR(gv(d, 'otherGstChargesVal'))],
        [cL('Total Fixed Charges', { bold: true, fill: TOTAL_FILL }), cTot(gv(d, 'totalFixedCharges'))],
      ];

      const Sec3_Left  = [T(['66%', '*'], Sec3_LeftRows, ZL_INNER_LAST)];
      const Sec3_Right = [
        T(['100%'], [[cTh('Summary', { fs: 10, margin: [0, 1, 0, 1] })]], ZL_INNER),
        T(['50%', '50%'], [
          [cLbl('Electricity Charges'),  cR(gv(d, 'elecCharges'))],
          [cLbl('Total Fixed Charges'),  cR(gv(d, 'totalFixed'))],
          [cLbl('Consumed Amount'),      cR(gv(d, 'consumedAmt'))],
          [cLbl('Recharged Amount'),     cR(gv(d, 'rechargedAmt'))],
          [cLbl('Dr/Cr Amount'),         cR(gv(d, 'drCrAmt'))],
          [cLbl('Opening Amount'),       cR(gv(d, 'openingAmt'))],
          [cL('Balance Amount', { bold: true, color: '#D35400', fill: '#FDEDEC' }), cR(gv(d, 'balanceAmt'), { bold: true, color: '#D35400', fill: '#FDEDEC' })],
        ], ZL_INNER_LAST)
      ];

      out.push({
        table: { widths: ['50%', '50%'], body: [[{ stack: Sec3_Left }, { stack: Sec3_Right }]] },
        layout: ZL_PARENT, margin: [0, 0, 0, 4]
      });

      // ── SECTION 4: TARIFF + RECEIPT ──────────────────────────────────
      // out.push(T(['50%', '50%'], tariffTableBody, ZL_STD, [0, 0, 0, 4]));
out.push(T(['100%'], [
  [
    cTh('NOTES', {
      fs: 10,
      margin: [0, 1, 0, 1]
    })
  ],
  [
    cC('', {
      margin: [0, 50, 0, 50], // Adjust this value to increase/decrease height
      fill: '#FAFAFA',
      bold: false
    })
  ]
], ZL_STD, [0, 0, 0, 4]));

      // ── DOTTED LINE ──────────────────────────────────────────────────
      out.push({
        canvas: [{ type: 'line', x1: 0, y1: 0, x2: 533, y2: 0, lineWidth: 1, lineColor: BORDER_COLOR, dash: { length: 4, space: 4 } }],
        margin: [0, 0, 0, 4]
      });

      // ── REMARKS ──────────────────────────────────────────────────────
      // out.push({ text: ':: Remarks ::', fontSize: 8, bold: true, italics: true, alignment: 'center', color: '#7F8C8D', margin: [0, 0, 0, 15] });

      // Remarks grid — conditionally show Grid/DG charge labels
      // const remarksRow1: any[] = [];
      // const remarksRow2: any[] = [];

      // if (mode === 'both' || mode === 'grid') {
      //   remarksRow1.push(
      //     cC('Grid Charge1', { fs: 6, color: '#7F8C8D' }),
      //     cC('Grid Charge2', { fs: 6, color: '#7F8C8D' }),
      //   );
      //   remarksRow2.push(
      //     cC('Grid Charge5', { fs: 6, color: '#7F8C8D' }),
      //     cC('Grid Charge6', { fs: 6, color: '#7F8C8D' }),
      //   );
      // }
      // if (mode === 'both' || mode === 'dg') {
      //   remarksRow1.push(
      //     cC('Grid Charge3', { fs: 6, color: '#7F8C8D' }),
      //     cC('Grid Charge4', { fs: 6, color: '#7F8C8D' }),
      //   );
      //   remarksRow2.push(
      //     cC('DG Charge1 :', { fs: 6, color: '#7F8C8D' }),
      //     cC('DG Charge2 :', { fs: 6, color: '#7F8C8D' }),
      //   );
      // }

      // // Pad to 4 columns if only one mode is active
      // while (remarksRow1.length < 4) remarksRow1.push(cC('', { fs: 6 }));
      // while (remarksRow2.length < 4) remarksRow2.push(cC('', { fs: 6 }));

      // out.push({
      //   table: {
      //     widths: ['25%', '25%', '25%', '25%'],
      //     body: [
      //       remarksRow1,
      //       remarksRow2,
      //       [cC('', { cs: 4, margin: [0, 25, 0, 5] }), {}, {}, {}] 
      //     ]
      //   }, layout: 'noBorders', margin: [0, 0, 0, 0]
      // });

      out.push({
        text: '* This is a computer-generated statement hence signature is not required.',
        fontSize: 7, bold: false, color: '#95A5A6', alignment: 'center', margin: [0, 0, 0, 0],
      });

      return out;
    }

    // ── Helpers ──────────────────────────────────────────────────────────
    function getColors(d: any) {
      return {
        BRAND_COLOR:  d?.color?.text        || '#003366',
        BORDER_COLOR: d?.color?.border      || '#BDC3C7',
        HEADER_FILL:  d?.color?.headerFill  || '#F0F4F8',
        TOTAL_FILL:   d?.color?.totalFill   || '#EAECEE',
        TEXT_COLOR:   d?.color?.textSecondary || '#333333'
      };
    }

function getLogoContent(d: any, BRAND_COLOR: string, alignment: string = 'center') {
  const type  = d.logoType;
  const value = d.logoValue;
  if (!value) return { text: '' };
  if (type === 'image') return { image: value, fit: [80, 50], alignment };
  return { text: value, fontSize: 18, bold: true, color: BRAND_COLOR };
}
function mapToData(item: any) {

  const format2 = (val: any): string => {
    const num = Number(val);
    return isNaN(num) ? "0.00" : num.toFixed(2);
  };

  return {
    statementTitle: "Monthly Statement",
    logoType:  item.logoType  || (item.logoBase64 ? 'image' : 'text'),  // ✅ add this
    logoValue: item.logoBase64 || item.logo || '',                // ✅ add this
    siteName: item.site_name || "",
    gstNo: item.ST_NO || "Not Provided",
    panNo: item.PAN_NO || "Not Provided",
    flat: item.flat_no || "",
    consumerName: item.consumer_name || "",
    address: `${item.site_address || ""} ${item.city || ""} ${item.state || ""} ${item.country || ""}`,

    tarrif_card: item.tarrif_card || [],
    flatType: item.flat_type || "",

    areaSqFt: format2(item.flat_area),
    gridLoad: format2(item.grid_load),
    dgLoad: format2(item.dg_load),

    billingMonth: item.billing_month || "",
    meterNo: item.meter_serial_no || "",

    mmcGrid: format2(item.grid_mmc_charges),
    mmcDG: format2(item.dg_mmc_charges),
    fixedGrid: format2(item.grid_fixed_charges),
    fixedDG: format2(item.dg_fixed_charges),

    cam: format2(item.CAM_charges),
    cs: format2(item.CS_charges),
    other: format2(item.other_charges),

    mmcDgGst: `${format2(item.dg_st_charge_mmc)}%`,
    fixedDgGst: `${format2(item.st_fixed_charges_dg)}%`,
    camGst: `${format2(item.a_cam_st_charges)}%`,
    csGst: `${format2(item.a_cs_st_charges)}%`,
    otherGstChg: `${format2(item.a_other_st_charges)}%`,

    gridOpen: format2(item.unit_grid_opening),
    gridConsumed: format2(item.consumed_unit_grid),
    gridClose: format2(item.unit_grid_closing),
    gridUnitChg: format2(item.grid_amt),

    dgOpen: format2(item.unit_dg_opening),
    dgConsumed: format2(item.consumed_unit_dg),
    dgClose: format2(item.unit_dg_closing),
    dgUnitChg: format2(item.dg_amt),

    gridPayConsumed: format2(item.grid_amt),
    gridPayMMC: format2(item.grid_mmc_charges),
    gridPayTax: format2(0),
    gridPayTotal: format2(item.grid_amt),

    dgPayConsumed: format2(item.dg_amt),
    dgPayMMC: format2(item.dg_mmc_charges),
    dgPayTax: format2(item.dg_amt_st),
    dgPayTotal: format2(item.dg_amt),

    totalPayable: format2(item.total_electricity_charges),

    gridTax1: `Gr.Ch1=${format2(item.grid_charge1_amt)} Gr.Ch2=${format2(item.grid_charge2_amt)} Gr.Ch3=${format2(item.grid_charge3_amt)}
Gr.Ch4=${format2(item.grid_charge4_amt)} | Gr.Ch5=${format2(item.grid_charge5_amt)} | Gr.Ch6=${format2(item.grid_charge6_amt)}`,

    dgTax1: `GST=${format2(item.dg_amt_st)} | Dg.Ch1=${format2(item.dg_charge1_amt)} |
Dg.Ch2=${format2(item.dg_charge2_amt)}`,

    commonAreaMaint: format2(item.CAM_charges),
    commonAreaMaintGst: format2(item.cam_st_mon),
    commonService: format2(item.CS_charges),
    commonServiceGst: format2(item.st_charges_cs),

    fixedGridStar: format2(item.grid_fixed_charges),
    fixedDGVal: format2(item.dg_fixed_charges),
    fixedGstDG: format2(item.st_fixed_charges_dg),

    otherChargesVal: format2(item.other_charges),
    otherGstChargesVal: format2(item.st_other_charges),

    totalFixedCharges: format2(
      Number(item.grid_fixed_charges || 0) +
      Number(item.dg_fixed_charges || 0) +
      Number(item.CAM_charges || 0) +
      Number(item.CS_charges || 0) +
      Number(item.other_charges || 0)
    ),

    elecCharges: format2(item.total_electricity_charges),
    totalFixed: format2(
      Number(item.grid_fixed_charges || 0) +
      Number(item.dg_fixed_charges || 0) +
      Number(item.CAM_charges || 0) +
      Number(item.CS_charges || 0) +
      Number(item.other_charges || 0)
    ),

    consumedAmt: format2(item.consumed_amt),
    rechargedAmt: format2(item.recharge_amt),
    drCrAmt: format2(item.dr_cr),
    openingAmt: format2(item.opening_amt),
    balanceAmt: format2(item.balance_amt),

    rFlat: item.flat_no || "",
    rName: item.consumer_name || "",
    rMonth: item.billing_month || "",

    rTotalFixed: format2(
      Number(item.grid_fixed_charges || 0) +
      Number(item.dg_fixed_charges || 0) +
      Number(item.CAM_charges || 0) +
      Number(item.CS_charges || 0) +
      Number(item.other_charges || 0)
    ),
    rRecharged: format2(item.recharge_amt),
    rDrCr: format2(item.dr_cr),
    rBalance: format2(item.balance_amt),
    rElec: format2(item.total_electricity_charges),
    rOpening: format2(item.opening_amt),
  };
}

    const pages  = List.map(mapToData);
    const content: any[] = [];
    pages.forEach((d: any, i: any) => {
      buildPage(d, i + 1, pages.length).forEach(x => content.push(x));
      if (i < pages.length - 1) content.push({ text: '', pageBreak: 'after' });
    });

    const fileName = `${List[0].site_name}-Monthly_Bill_Report.pdf`;
    this.content = content
    pdfMake.createPdf({
      pageSize:{ width: 595, height: 870 },
      pageMargins: [33, 20, 29, 20],
      defaultStyle: { font: 'Roboto', fontSize: 8, bold: true, lineHeight: 1.15 },
      content,
    }).getBlob((blob: Blob) => {

      const url = URL.createObjectURL(blob);

      this.pdfPreviewSubject.next({
        url,
        name: fileName
      });

    });
  }

}